import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Packages from './pages/Packages'
import Destination from './pages/Destination'
import Booking from './pages/Booking'
import Team from './pages/Team'
import Testimonial from './pages/Testimonial'
import Error from './pages/Error'
import Contact from './pages/Contact'
import VisaAssistance from './pages/VisaAssistance'
import VisaVaccination from './pages/VisaVaccination'
import VaccinationCertificate from './pages/VaccinationCertificate'
import Blogs from './pages/Blogs'
import BlogDetail from './pages/BlogDetail'
import Consultancy from './pages/Consultancy'
import WhatsAppIcon from './pages/WhatsAppIcon'
import HotelBooking from './pages/HotelBooking'
import TestEmail from './pages/TestEmail'

// Flight Booking module (mock-API driven)
import ScrollToTop from './components/ScrollToTop'
import { BookingProvider } from './context/BookingContext'
import RequireBookingStep from './components/booking/RequireBookingStep'
import FlightListing from './pages/booking/FlightListing'
import FlightSearch from './pages/booking/FlightSearch'
import FlightResults from './pages/booking/FlightResults'
import PassengerDetails from './pages/booking/PassengerDetails'
import ReviewBooking from './pages/booking/ReviewBooking'
import Payment from './pages/booking/Payment'
import Confirmation from './pages/booking/Confirmation'

// Admin panel module
import { AdminProvider } from './context/AdminContext'
import RequireAdminAuth from './components/admin/RequireAdminAuth'
import AdminLogin from './pages/admin/AdminLogin'
import AdminLayout from './pages/admin/AdminLayout'
import CreatePackageTab from './pages/admin/CreatePackageTab'
import ReviewTab from './pages/admin/ReviewTab'
import PublishTab from './pages/admin/PublishTab'
import CreateBlogTab from './pages/admin/CreateBlogTab'
import ReviewBlogTab from './pages/admin/ReviewBlogTab'
import PublishBlogTab from './pages/admin/PublishBlogTab'
import VaccinationApplicationsTab from './pages/admin/VaccinationApplicationsTab'

export default function App() {
  const location = useLocation()
  const isAdminRoute = location.pathname.startsWith('/adminpanel')

  return (
    <BookingProvider>
      <AdminProvider>
        <ScrollToTop />
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        {!isAdminRoute && <Header />}
        {!isAdminRoute && <WhatsAppIcon />}
        <Routes>
        <Route path='/adminpanel/login' element={<AdminLogin/>} />
        <Route path='/adminpanel' element={
          <RequireAdminAuth>
            <AdminLayout/>
          </RequireAdminAuth>
        }>
          <Route index element={<Navigate to="create" replace />} />
          <Route path='create' element={<CreatePackageTab/>} />
          <Route path='review' element={<ReviewTab/>} />
          <Route path='publish' element={<PublishTab/>} />
          <Route path='blogs/create' element={<CreateBlogTab/>} />
          <Route path='blogs/review' element={<ReviewBlogTab/>} />
          <Route path='blogs/publish' element={<PublishBlogTab/>} />
          <Route path='vaccination-applications' element={<VaccinationApplicationsTab/>} />
        </Route>

        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/services' element={<Services/>}/>
        <Route path='/packages' element={<Packages/>}/>
        <Route path='/destination' element={<Destination/>}/>
        <Route path='/booking' element={<Booking/>}/>
        <Route path='/team' element={<Team/>}/>
        <Route path='/testimonial' element={<Testimonial/>}/>
        <Route path='/error' element={<Error/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/VisaAssistance' element={<VisaAssistance/>} />
        <Route path='/VisaVaccination' element={<VisaVaccination/>} />
        <Route path='/VisaVaccination/certificate/:vaccine' element={<VaccinationCertificate/>} />
        <Route path='/blogs' element={<Blogs/>} />
        <Route path='/blogs/:slug' element={<BlogDetail/>} />
        <Route path='/Consultancy' element={<Consultancy/>} />
        <Route path='/HotelBooking' element={<HotelBooking/>} />
        <Route path='/TestEmail' element={<TestEmail/>} />

        {/* Flight Booking flow */}
        <Route path='/flights' element={<FlightListing/>} />
        <Route path='/bookingflight' element={<FlightSearch/>} /> 
        {/* // rohit */}

        <Route path='/bookingflight/results' element={
          <RequireBookingStep needs={['searchCriteria']}>
            <FlightResults/>
          </RequireBookingStep>
        } />
        <Route path='/bookingflight/passenger' element={
          <RequireBookingStep needs={['selectedFlight']}>
            <PassengerDetails/>
          </RequireBookingStep>
        } />
        <Route path='/bookingflight/review' element={
          <RequireBookingStep needs={['selectedFlight', 'passengers']}>
            <ReviewBooking/>
          </RequireBookingStep>
        } />
        <Route path='/bookingflight/payment' element={
          <RequireBookingStep needs={['selectedFlight', 'passengers', 'fare']}>
            <Payment/>
          </RequireBookingStep>
        } />
        <Route path='/bookingflight/confirmation' element={
          <RequireBookingStep needs={['confirmation']}>
            <Confirmation/>
          </RequireBookingStep>
        } />
        </Routes>
        {!isAdminRoute && <Footer />}
      </AdminProvider>
    </BookingProvider>
  )
}
